<template>
  <v-flex sm10 offset-sm1>
    <v-container fluid>
      <v-flex>
        <v-card class="elevation-0 mb-5 pb-5">
          <div primary-title class="primary--text pa-2 mb-4 mt-3">
            <h3 class="display-1 mb-0 ml-3">{{ 'downgrade.title' | t }}</h3>
          </div>
          <v-flex md6 offset-md3 class="mt-4">
            <v-card class="elevation-0">
              <v-card-title primary-title>
                <v-flex v-if="status === 2">
                  <div class="text-xs-center mt-2 mb-2">
                    <v-icon dark color="green" x-large>check_circle</v-icon>
                  </div>
                  <div
                    class="subheading mt-3 text-xs-center"
                  >{{ $t('downgrade.confirm', { product_name }) }}</div>
                  <div class="subheading mt-5 text-xs-center">
                    <v-btn color="primary ml-2" to="/home" dark>{{ 'downgrade.button' | t }}</v-btn>
                  </div>
                </v-flex>
                <v-flex v-if="status === 5">
                  <div class="subheading mt-3 text-xs-center">{{ 'downgrade.loading' | t }}</div>
                  <div class="subheading mt-3 text-xs-center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>
                </v-flex>
                <v-flex v-if="status === 6">
                  <div class="text-xs-center mt-2 mb-2">
                    <v-icon dark color="red" x-large>error</v-icon>
                  </div>
                  <div class="subheading mt-3 text-xs-center">{{ 'downgrade.problem' | t }}</div>
                  <div class="subheading mt-5 text-xs-center">
                    <v-btn color="primary ml-2" to="/shop" dark>{{ 'downgrade.button' | t }}</v-btn>
                  </div>
                </v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-container>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      status: 5,
      product_name: "Developer"
    };
  },
  computed: {
    ...mapGetters(["getServer", "getTokenHeader", "getProduct"])
  },
  mounted() {
    if (this.getProduct === 0) this.rmKey();
    else {
      this.$http
        .get(
          `${this.getServer}/shop/downgrade/${this.getProduct}`,
          this.getTokenHeader
        )
        .then(res => {
          if (res.data.error) this.status = 6;
          else {
            this.product_name = res.data.product_name;
            this.status = res.data.status;
          }
        });
    }
  },
  methods: {
    ...mapActions(["rmKey"])
  }
};
</script>
